import React from 'react';
import { Modal, Radio } from 'antd';
import { translate } from 'react-i18next';
import { compose } from 'redux';
const RadioGroup = Radio.Group;

class StudentFilter extends React.Component {

  constructor() {
    super();
    this.state = {
      selected: 'all'
    }
  }

  changeSelection = (name, id) => {
    this.props.selectStudent(name, id)
    this.setState({selected: name})
  }

  render() {

    if (this.state.selected != 'all' &&  this.props.selectedStudent.id == 'all') {
      this.setState({selected: 'all'})
    }

    const { t } = this.props;
    return (
      <div>
       <Modal
         style={modal}
         bodyStyle={{  maxHeight: '70vh', overflow: 'scroll'}}
         title="Students"
         visible={this.props.isOpen}
         onCancel={this.props.close}
         footer={false}
         width="300px"
       >
       <RadioGroup value={this.state.selected} onChange={(e) => this.changeSelection(e.target.value, e.target.id)}>
          <Radio style={{width: '100%'}} value='all' >{t('All students')}</Radio>
         {this.props.students && this.props.students.map( student =>
           <Radio style={{width: '100%'}} id={student[1].profile.name} value={student[0]}>
              {student[1].profile.name} {student[1].profile.last_name}
           </Radio>
         )}
       </RadioGroup>
       </Modal>
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
)
export default enhancer(StudentFilter);


const modal = {
  position: 'absolute',
  right: '60px',
}



// WEBPACK FOOTER //
// ./src/components/StudentFilter/index.jsx